/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RenameProcedureFileDto
 */
export interface RenameProcedureFileDto {
    /**
     * The file type to rename
     * @type {string}
     * @memberof RenameProcedureFileDto
     */
    fileType: RenameProcedureFileDtoFileTypeEnum;
    /**
     * New custom name for the file
     * @type {string}
     * @memberof RenameProcedureFileDto
     */
    customName: string;
}


/**
 * @export
 */
export const RenameProcedureFileDtoFileTypeEnum = {
    Txt: 'txt',
    Pdf: 'pdf'
} as const;
export type RenameProcedureFileDtoFileTypeEnum = typeof RenameProcedureFileDtoFileTypeEnum[keyof typeof RenameProcedureFileDtoFileTypeEnum];


/**
 * Check if a given object implements the RenameProcedureFileDto interface.
 */
export function instanceOfRenameProcedureFileDto(value: object): value is RenameProcedureFileDto {
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    if (!('customName' in value) || value['customName'] === undefined) return false;
    return true;
}

export function RenameProcedureFileDtoFromJSON(json: any): RenameProcedureFileDto {
    return RenameProcedureFileDtoFromJSONTyped(json, false);
}

export function RenameProcedureFileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenameProcedureFileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fileType': json['fileType'],
        'customName': json['customName'],
    };
}

export function RenameProcedureFileDtoToJSON(json: any): RenameProcedureFileDto {
    return RenameProcedureFileDtoToJSONTyped(json, false);
}

export function RenameProcedureFileDtoToJSONTyped(value?: RenameProcedureFileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileType': value['fileType'],
        'customName': value['customName'],
    };
}

